import React from "react";
import I18n from "../../../../base/i18n.js";

import { withStyles } from '@material-ui/styles';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js';
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";

import ListUsersUseCase from "../../../../use_cases/admin/users/users/list_users_use_case.js";
import { UserModel } from "../../../../models/users/user_model.js";

import BaseListPage from "../../base_list_page.js";

const styles = theme => ({
});

class UsersListPage extends BaseListPage {
  
}

UsersListPage.defaultProps = {
  dataModel: UserModel,
  listUseCase: ListUsersUseCase
}

export default compose(
  withLocationSearchFilter,
  withShowToast, 
  withCurrentUser, 
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(UsersListPage);
